import { useMutation } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { withErrorHandling } from '@/modules/common/utils/error-utils.tsx';

export const useIssuerSelfAssignInvestorRole = () => {
  return useMutation({
    mutationFn: async (register_id: number) => {
      const response = await withErrorHandling(
        api.v1.applyInvestorRoleV1UsersApplyInvestorRolePut({ register_id }),
        {
          loading: 'Subscription...',
          success: 'Subscribed successfully',
        },
      );

      return response.data;
    },
  });
};
